import { useEffect, useRef, useState } from "react";
import {
    useMapsLibrary,
} from '@vis.gl/react-google-maps';
import { useStyles } from "./styles";
import { TextField } from "@mui/material";

interface PlaceAutocompleteProps {
    onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
    value?: string
    setDisableName: React.Dispatch<React.SetStateAction<boolean>>
    setValue: (value: React.SetStateAction<string>) => void
}

const PlaceAutocomplete = ({ onPlaceSelect, value, setDisableName, setValue }: PlaceAutocompleteProps) => {
    const [placeAutocomplete, setPlaceAutocomplete] =
        useState<google.maps.places.Autocomplete | null>(null);
    const inputRefConst = useRef<HTMLInputElement>(null);
    const places = useMapsLibrary('places');
    const styles = useStyles()
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!value || !inputRefConst.current) return;

        inputRefConst.current.value = value; // Asignando valor correctamente
        //setInputValue(value);
    }, [value]);

    useEffect(() => {
        if (!places || !inputRefConst.current) return;

        const options = {
            fields: ['geometry', 'name', 'formatted_address'],
            strictBounds: false, // Evita que el autocompletado agregue su propio input
            //types: ['geocode']
        };

        setPlaceAutocomplete(new places.Autocomplete(inputRefConst.current, options));
    }, [places, inputRefConst.current]);

    useEffect(() => {
        if (!placeAutocomplete) return;

        const listener = placeAutocomplete.addListener('place_changed', () => {
            //onPlaceSelect(placeAutocomplete.getPlace());
            const place = placeAutocomplete.getPlace();
            onPlaceSelect(place);
            setValue(place.formatted_address ?? '');
        });

        return () => {
            if (listener) {
                listener.remove();
            }
        };
    }, [onPlaceSelect, placeAutocomplete]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setValue(newValue);

        if (newValue.length < 3) {
            setError(true);
            setDisableName(true)
        } else {
            setError(false);
            setDisableName(false)
        }
    };



    return (
        <div style={styles.mapContainer}>
            <TextField
                inputRef={inputRefConst}
                fullWidth
                variant="outlined"
                label="Nombre del destino"
                placeholder="Ej: Calle 1 # 2-3, Barrio, Ciudad"
                value={value}
                onChange={handleInputChange}
                error={error}
                helperText={error ? "El campo debe tener al menos 3 caracteres" : ""}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'grey.300', // Color del borde
                        },
                        '&:hover fieldset': {
                            borderColor: 'primary.main', // Color del borde al pasar el mouse
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'primary.main', // Color del borde al enfocar
                        },
                    },
                }}
            />
        </div>
    );
};

export { PlaceAutocomplete }